import { SxProps, Theme } from '@mui/material';

const iconButton = (isSorted: boolean, isActive: boolean): SxProps<Theme> => ({
  color: isSorted
    ? 'customGrey.light'
    : isActive
    ? 'primary.main'
    : 'customGrey.dark'
});

// Above the chat panel beside the table, below the select's menu.
const popper: SxProps<Theme> = { zIndex: (theme) => theme.zIndex.modal - 1 };

const paper: SxProps<Theme> = {
  width: '360px',
  boxSizing: 'border-box',
  p: '20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
  border: '1px solid',
  borderColor: 'customGrey.dark',
  borderRadius: 0,
  boxShadow: 'none'
};

const title: SxProps<Theme> = {
  fontSize: '14px',
  fontWeight: 700,
  color: 'customGrey.dark'
};

const select: SxProps<Theme> = { height: '52px', fontSize: '14px' };

const row: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px'
};

const inputBase: SxProps<Theme> = {
  flexShrink: 0,
  '& .MuiOutlinedInput-root': { height: '52px', borderRadius: 0 },
  '& input': { textAlign: 'center', px: 1, MozAppearance: 'textfield' },
  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    WebkitAppearance: 'none',
    margin: 0
  }
};

const input: SxProps<Theme> = { ...inputBase, width: '60px' };

const dateRow: SxProps<Theme> = { display: 'flex', gap: '15px' };

const dateField: SxProps<Theme> = {
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '15px'
};

const monthField: SxProps<Theme> = {
  ...dateField,
  width: '120px',
  flexShrink: 1,
  minWidth: 0
};

const dayField: SxProps<Theme> = { ...dateField, width: '65px' };

const yearField: SxProps<Theme> = { ...dateField, width: '105px' };

const dateInput: SxProps<Theme> = { ...inputBase, width: '100%' };

const apply: SxProps<Theme> = { mt: '20px', py: '14px' };

const clear: SxProps<Theme> = {
  alignSelf: 'center',
  fontSize: '16px',
  fontWeight: 700
};

export const rangeFilterSx = {
  iconButton,
  popper,
  paper,
  title,
  select,
  row,
  dateRow,
  monthField,
  dayField,
  yearField,
  dateInput,
  input,
  apply,
  clear
};
